// @ts-nocheck
(function () {
  if (window.__fbCombinedListingTrackerInit) return;
  window.__fbCombinedListingTrackerInit = true;

  // Fires Meta ViewContent for every product-page variant change, including combined-listing colour
  // switches (a different product). On a switch, assets/variant-picker.js has already copied the new
  // product's data into window.__fbProduct (from the product section's data-product-tracking-data JSON)
  // before variant:update is dispatched.
  document.addEventListener('variant:update', function (e) {
    var detail = e.detail;
    if (!detail || !detail.resource) return;
    if (typeof fbq !== 'function') return;

    var resource = detail.resource;
    var variantId = resource.id != null ? resource.id : null;
    var priceCents = resource.price != null ? resource.price : 0;

    if (!variantId) return;

    // Derive product title by stripping the variant suffix from resource.name
    // e.g. "Wimberley 3.0 Bedding Set - Wimberley / California King" → "Wimberley 3.0 Bedding Set"
    var title = resource.name
      ? resource.name.replace(' - ' + resource.title, '').trim()
      : '';

    var type = (window.__fbProduct && window.__fbProduct.type) || '';

    fbq('track', 'ViewContent', {
      content_ids: [String(variantId)],
      content_name: title,
      content_category: type,
      content_type: 'product',
      currency: 'USD',
      value: priceCents / 100
    });
  });
})();
